import { commonUtils } from '@/helpers/commonUtils'
import styles from './PdfPage1.module.less'
import PdfPage, { PageHeader } from '../PdfPage/PdfPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  no: number
}

function PdfPage1(props: Props) {
  const { t } = useTranslation()
  useEffect(() => {
    props.onRendered(1)
  }, [])
  return (
    <PdfPage no={props.no} bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-1/PDF-bg-1.jpg')}>
      <div className={styles.pdfPage1}>
        <PageHeader project={props.project} />
        <div className={styles.briefLine}></div>
        <p className={styles.title}>{props.project.adName}</p>
        <p className={styles.desc}>{t('landing.info.title')}</p>
        <img
          className={styles.next}
          src={commonUtils.getImagePath('PDFDownload/pdf-page-1/next.png')}
          alt=''
        />
      </div>
    </PdfPage>
  )
}

export default PdfPage1
